import React from "react";
import logo from '../../logo.svg';

export default function Logo() {
  return (
    <img src="/logo/logo-white.png" className="App-logo" alt="logo" />
  )
}